<template>
	<div class="col-12 col-md-6 col-lg-4 mt-4">
		<div class="card document-card">
			<div class="row justify-content-center h-100">
				<b-col
					cols="11"
					sm="8"
					md="10"
					lg="11"
					class="d-flex flex-column"
				>
					<div class="w-100">
						<div class="d-flex">
							<div class="card-icon icon-doc" />
							<div class="title ml-2 text-left">
								{{ field.name }}
							</div>
						</div>

						<div
							v-if="(!additionalData || !additionalData.fileName) && !uploadProcess"
							class="price-box"
						>
							<label class="btn btn-primary-outer btn-icon icon-doc document-input-container">
								Загрузить
								<input
									id="file-input"
									:ref="refName"
									class="document-input"
									type="file"
									accept="image/*"
									@change="handleFileUpload"
								>
							</label>
							<!--<div class="btn btn-primary-outer btn-icon icon-cam">
								Камера
							</div>-->
						</div>
						<div
							v-if="additionalData && additionalData.fileName && !uploadProcess"
							class="price-box"
						>
							<div class="d-flex justify-content-between align-center">
								<div class="flex-grow-1 document-name-file">
									{{ additionalData.fileName }}
								</div>
								<div class="btn btn-sm btn-link icon-close" @click="handleFileClear" />
							</div>
						</div>
						<div v-if="uploadProcess" class="price-box">
							<div class="d-flex justify-content-center">
								<div class="col-8">
									<b-progress max="1" class="mb-3 mt-2" show-progress animated>
										<b-progress-bar value="1" label="загрузка" />
									</b-progress>
								</div>
							</div>
						</div>
						<div v-if="uploadError || errorMaxSize || errorNotPermittedType" class="error-box">
							<div class="d-flex justify-content-between align-center">
								<div
									class="flex-grow-1 document-upload-error"
								>
									{{ uploadError ? 'Ошибка при загрузке изображения, попробуйте еще.' : '' }}
									{{ errorMaxSize ? 'Размер файла не должен превышать 5 мб.' : '' }}
									{{ errorNotPermittedType ? 'Можно загружать только изображения и pdf.' : '' }}
								</div>
								<div class="btn btn-sm btn-link icon-close" @click="handleErrorClear" />
							</div>
						</div>

						<div class="text-left mb-3">
							<div class="custom-control custom-checkbox mb-2">
								<input
									:id="laterUploadId"
									v-model="laterUpload"
									type="checkbox"
									class="custom-control-input"
								>
								<label class="custom-control-label" :for="laterUploadId">
									Скан предоставлю позже
								</label>
							</div>
						</div>

						<!-- Верстка - поля с данными документов -->
						<div v-if="field.children" class="text-left">
							<base-field
								v-for="childField in field.children"
								:key="childField.field_id"
								ref="childFields"
								:field="childField"
								:person-number="personNumber"
								:form-data="formData"
								@blur="onBlur"
							/>
						</div>

						<div v-if="options.skippedUpload" class="col-12 text-left">
							<div class="custom-control custom-checkbox mb-2">
								<input id="customCheck1" type="checkbox" class="custom-control-input">
								<label class="custom-control-label" for="customCheck1">
									Нет высшего образования
									<br>
									<small>Стоимость обучения увеличится на размер НДС</small>
								</label>
							</div>
						</div>

						<b-form-text v-if="field.hint">
							{{ field.hint }}
						</b-form-text>
					</div>
				</b-col>
			</div>
		</div>
	</div>
</template>

<script>
import {
	CHECKOUT_STORE_NAMESPACE,
	MUTATION_SET_FORM_FIELDS_DATA,
} from '@/store/checkout';

const MAXIMUM_SIZE_FILE = 5 * 1024 * 1024; // мегабайт
const PERMITTED_TYPES = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tiff', '.tif', '.webp', '.pdf']; // разрешенные типы файлов для загрузки на сервер

export default {
	name: 'UploadExplicit',
	components: { BaseField: () => import(/* webpackChunkName: "base-field" */'../CheckoutBaseField.vue') },
	props: {
		field: {
			type: Object,
			default: () => ({}),
		},
		personNumber: {
			type: Number,
			default: 1,
		},
		formData: {
			type: Object,
			default: () => ({}),
		},
		additionalData: {
			type: Object,
			default: () => ({}),
		},
		// eslint-disable-next-line vue/require-prop-types
		value: { default: null },
	},
	data() {
		return {
			fileName: this.additionalData
				? this.additionalData?.fileName || ''
				: '',
			uploadProcess: false,
			uploadError: false,
			errorMaxSize: false,
			errorNotPermittedType: false,
			isValidate: null,
			isValidateChildren: null,
			laterUpload: false,
		};
	},
	computed: {
		refName() {
			return `file${this.field.field_id}_${this.personNumber}`;
		},
		options() {
			if (this.field?.options || null) {
				return this.field?.options;
			}

			return {};
		},
		laterUploadId() {
			return `later-upload_${this.field.form_field_id}_${this.personNumber}`;
		},
	},
	methods: {
		onBlur() {
			this.$emit('blur', this.fileName, this.isValidate, true);
		},
		handleErrorClear() {
			this.uploadError = false;
			this.errorMaxSize = false;
			this.errorNotPermittedType = false;
		},
		handleFileUpload() {
			const file = this.$refs[this.refName]?.files[0] || '';

			if (!file) {
				return;
			}

			const typeMatch = file.name.match(/\.\w+$/i);
			if (!typeMatch) {
				console.warn('Файл со сломанным расширением');
				return;
			}

			const typeFile = typeMatch[0];
			if (!PERMITTED_TYPES.includes(typeFile)) {
				this.handleErrorClear();
				this.errorNotPermittedType = true;
				return;
			}

			if (file.size >= MAXIMUM_SIZE_FILE) {
				this.handleErrorClear();
				this.errorMaxSize = true;
				return;
			}

			this.fileName = file.name;

			// отправляем документ
			this.uploadProcess = true;
			const formData = { file, form_field_id: this.field.form_field_id };
			this.$api.checkoutFormSaveDocument(formData).then(
				({ data }) => {
					this.handleErrorClear();
					this.uploadProcess = false;
					this.uploaded = true;
					this.setStoreData(data.id, data.file.name);
				},
				() => {
					this.uploadProcess = false;
					this.uploadError = true;
					this.handleFileClear();
				},
			);
		},
		handleFileClear() {
			this.fileName = '';
			this.uploaded = false;
			this.$api.checkoutFormRemoveDocument();
			this.setStoreData(null, null);
		},
		setStoreData(imageId, fileName) {
			this.$store.commit(
				`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_FORM_FIELDS_DATA}`,
				{
					fields: {
						[this.personNumber]: {
							[this.field.slug]: {
								additionalData: { fileName },
								value: imageId || null,
								personNumber: this.personNumber,
								formFieldId: this.field.form_field_id,
							},
						},
					},
					formId: this.formData.id,
				},
			);

			this.$emit('change');
			this.$emit('blur', fileName);
		},
		checkChildrenValidation(form) {
			this.isValidateChildren = true;
			if (Array.isArray(this.$refs.childFields)) {
				this.$refs.childFields.forEach((field) => {
					if (typeof field.checkValidation === 'function') {
						const isValid = field.checkValidation(form);
						if (isValid === false) this.isValidateChildren = false;
					}
				});
			}
		},
		approveChildrenValidation() {
			if (Array.isArray(this.$refs.childFields)) {
				this.$refs.childFields.forEach((field) => {
					if (typeof field.checkValidation === 'function') {
						field.approveValidation();
					}
				});
			}
		},
		/**
		 * Проверяем валидность по библиотеке vuelidate
		 * @param form Объект, сгенерированный vuelidate, содержит инфу об ошибках
		 */
		checkValidation(form) {
			this.isValidate = typeof form[this.field.slug]?.$error !== 'undefined' ? !form[this.field.slug]?.$error : true;
			if (this.isValidate === false) this.uploadError = true;

			if (this.laterUpload) {
				this.isValidate = true;
				this.uploadError = false;
			}

			this.checkChildrenValidation(form);

			return this.isValidate && this.isValidateChildren;
		},
		getChildrenValues() {
			if (!Array.isArray(this.$refs.childFields)) {
				return null;
			}
			return this.$refs.childFields.reduce((acc, field) => {
				if (!field.field?.slug) return acc;

				acc[field.field.slug] = field.fieldValue;

				return acc;
			}, {});
		},
	},
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/home/prog-registration";

	.document-upload-error {
		font-size: 12px;
		color: red;
	}
	.document-input-container {
		position: relative;
		margin-bottom: 0;
		// overflow: hidden;
	}

	.document-input {
		position: absolute;
		top: 0;
		left: 0;
		z-index: -1;
		width: 0;
		height: 0;
		opacity: 0;
	}
	.document-name-file {
		overflow: hidden;
		text-align: left;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.error-box {
		position: relative;
		padding: 0 0 1rem;
		margin-bottom: 1rem;
		border-bottom: 1px solid;
	}
</style>
